<template>
  <section id="work" class="work">
    <div class="shell">
      <header v-reveal class="section-head">
        <h2>Recent client work</h2>
        <p>Two recent projects, both live, so you can try them yourself.</p>
      </header>
      <div class="work-grid">
        <article
          v-for="(project, i) in projects"
          :key="project.name"
          v-reveal
          class="work-card"
          :style="{ transitionDelay: `${i * 90}ms` }"
        >
          <div class="work-visual" :class="`tint-${project.tint}`">
            <BrowserFrame
              :src="project.image"
              :srcset="`${project.imageSmall} 1200w, ${project.image} 2160w`"
              sizes="(max-width: 860px) calc(100vw - 96px), 500px"
              :label="project.host"
              :alt="`The ${project.name} website`"
            />
          </div>
          <div class="work-copy">
            <p class="work-kind">{{ project.kind }}</p>
            <h3>{{ project.name }}</h3>
            <p class="work-body">{{ project.body }}</p>
            <p class="work-built"><span>What I built</span>{{ project.built }}</p>
            <a
              class="text-link"
              :href="project.url"
              target="_blank"
              rel="noopener noreferrer"
              >Visit {{ project.host }}
              <span aria-hidden="true">↗</span
              ><span class="sr-only"> (opens in a new tab)</span></a
            >
          </div>
        </article>
      </div>
      <p v-reveal class="work-note">
        Most backend work runs out of sight: nightly report imports,
        payment-processor integrations, data pipelines. Those systems belong to
        the businesses that run them, so they aren’t shown here. I’m happy to
        talk through how they work.
      </p>
    </div>
  </section>
</template>
<script>
import BrowserFrame from "@/components/graphics/BrowserFrame.vue";
import projects from "@/config/projects";

export default {
  name: "WorkSection",
  components: { BrowserFrame },
  data: () => ({ projects }),
};
</script>
